import {
  SET_GROUP_DRAFTS,
  PUBLISH_GROUP_REQUEST,
  PUBLISH_GROUP_SUCCESS,
  PUBLISH_GROUP_FAILURE,
  FETCH_GROUPS_REQUEST,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_FAILURE,
} from "../types/fabricGroupTypes";

const initialState = {
  drafts: [],
  publishedGroups: [],
  loading: false,
  publishing: false,
  error: null,
};

const fabricGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    // index.js runs redux-localstorage-simple's save()/load() with no `states`
    // filter, so this slice is snapshotted and rehydrated wholesale -- which
    // would restore a stuck `loading: true` and stale drafts. loadDrafts() is
    // dispatched on app start and re-reads localStorage, which is the source of
    // truth, so treat it as the reset point for the transient fields too.
    case SET_GROUP_DRAFTS:
      return {
        ...state,
        drafts: action.payload || [],
        loading: false,
        publishing: false,
        error: null,
      };

    case PUBLISH_GROUP_REQUEST:
      return { ...state, publishing: true, error: null };
    case PUBLISH_GROUP_SUCCESS:
      return { ...state, publishing: false };
    case PUBLISH_GROUP_FAILURE:
      return { ...state, publishing: false, error: action.payload };

    case FETCH_GROUPS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_GROUPS_SUCCESS:
      return { ...state, loading: false, publishedGroups: action.payload };
    case FETCH_GROUPS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default fabricGroupReducer;
